import { render, staticRenderFns } from "./Pg.vue?vue&type=template&id=5514d776&scoped=true"
import script from "./Pg.vue?vue&type=script&lang=js"
export * from "./Pg.vue?vue&type=script&lang=js"
import style0 from "./Pg.vue?vue&type=style&index=0&id=5514d776&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5514d776",
  null
  
)

export default component.exports